// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__1pncF","label":"SetPasswdForm_label__2SWn_"};